export const ADMIN = 'ADMIN';
export const MANAGER = 'MANAGER';
export const ADMIN_RO = 'READ_ONLY_ADMIN';
export const AGENT = 'AGENT';
export const BUSINESS = 'BUSINESS';
export const BUSINESS_ADMIN = 'BUSINESS_ADMIN';
export const BUSINESS_AGENT = 'BUSINESS_AGENT';
export const USER = 'USER';
export const RESELLER = 'RESELLER';
export const RESELLER_ADMIN = 'RESELLER_ADMIN';
export const RESELLER_AGENT = 'RESELLER_AGENT';
export const RESOLD_USER = 'RESOLD_USER';
export const BILLING = 'BILLING';
export const TRAINEE = 'TRAINEE';

export const BUSINESS_GROUP = [BUSINESS, BUSINESS_ADMIN, BUSINESS_AGENT];
export const RESELLER_GROUP = [RESELLER, RESELLER_ADMIN, RESELLER_AGENT];
